'use strict';

module.exports = require('./is-implemented')()
	? String.prototype.contains
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es5-ext/string/#/contains/index.js
 ** module id = 78
 ** module chunks = 2
 **/